var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinacialIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9232",
    "data-name": "Group 9232",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.038,
    height: 19.039,
    viewBox: "0 0 19.038 19.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3130",
    "data-name": "Rectangle 3130",
    width: 19.038,
    height: 19.039,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9231",
    "data-name": "Group 9231",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M9.522,32.033h7.407a.679.679,0,0,1,.745.557,2.457,2.457,0,0,1,.007.509,8.61,8.61,0,0,1-1.111,3.893,8.738,8.738,0,0,1-4.217,3.841A8.651,8.651,0,0,1,9.8,41.5a8.48,8.48,0,0,1-3.375-.28,9.5,9.5,0,0,1-2.149-.951A8.875,8.875,0,0,1,.849,36.479,8.693,8.693,0,0,1,.1,33.98a8.308,8.308,0,0,1-.082-1.852,8.6,8.6,0,0,1,.76-3.062A8.764,8.764,0,0,1,4.247,25.15a8.4,8.4,0,0,1,3.3-1.172c.424-.057.852-.087,1.279-.1a.664.664,0,0,1,.7.7q0,3.651,0,7.3v.155M8.164,25.271a7.474,7.474,0,1,0,8.113,8.12H8.945a.75.75,0,0,1-.616-.255.816.816,0,0,1-.165-.547q0-3.582,0-7.164v-.154",
    transform: "translate(0 -22.52)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M192.113,4.046q0-1.637,0-3.273a.725.725,0,0,1,.88-.766c.26.027.522.038.781.071A7.058,7.058,0,0,1,196.32.9a7.466,7.466,0,0,1,2.864,2.7,7.7,7.7,0,0,1,.929,2.469,6.486,6.486,0,0,1,.146,1.336.648.648,0,0,1-.329.615,1.031,1.031,0,0,1-.455.114c-2.189.007-4.379.005-6.568,0a.724.724,0,0,1-.793-.792q0-1.653,0-3.305m6.776,2.743c-.032-.187-.056-.365-.093-.54a7.228,7.228,0,0,0-.549-1.567A5.563,5.563,0,0,0,197.1,3.136,6.052,6.052,0,0,0,193.61,1.4c-.152-.022-.152-.023-.152.127q0,2.566,0,5.132v.126Z",
    transform: "translate(-181.221 0)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinacialIcon);
export default __webpack_public_path__ + "static/media/finacial-icon.30ee41e6c94837d8edd5d7f876d4a65c.svg";
export { ForwardRef as ReactComponent };